var React = require('react');

function MyProfileProfileIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","style":{"fill":"none"},"key":0}),React.createElement("g",{"id":"_01_align_center","key":1},[React.createElement("path",{"id":"Path_6998","d":"M16.8,19h-1.5v-3.8c0-1.2-1-2.2-2.2-2.2h-6.1c-1.2,0-2.2,1-2.2,2.2v3.8h-1.5v-3.8c0-2.1,1.7-3.7,3.7-3.7h6.1c2.1,0,3.7,1.7,3.7,3.7v3.8Z","style":{"fill":"#5b6070"},"key":0}),React.createElement("path",{"id":"Path_6999","d":"M10,10c-2.5,0-4.5-2-4.5-4.5S7.5,1,10,1s4.5,2,4.5,4.5h0c0,2.5-2,4.5-4.5,4.5ZM10,2.5c-1.7,0-3,1.3-3,3s1.3,3,3,3,3-1.3,3-3h0c0-1.7-1.3-3-3-3Z","style":{"fill":"#5b6070"},"key":1})])]);
}

MyProfileProfileIcon.defaultProps = {"id":"Layer_1","width":"20","height":"20","version":"1.1","viewBox":"0 0 20 20"};

module.exports = MyProfileProfileIcon;

MyProfileProfileIcon.default = MyProfileProfileIcon;
